import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
    Text,
    TextTypes,
    Button,
    showLoader,
    showToast,
    ToastVariants,
} from '../../components/index';
import '../../styles/order-card.scss';
import OrderDesktop from './order-desktop';
import OrderMobile from './order-mobile';
import './order-detail.scss';
import Service from '../../services/apolloClient.service';
import { Order, GiftCard } from '../../types/graphql-global-types';
import { constants } from '../../constants';
import util from '../../util';
import styleLoader from '../../components/style-loader/style-loader';

interface OrderDetailProps {
    history: any;
    match: any;
    response: any;
}

function OrderDetail({ response }: OrderDetailProps) {
    const [order, setOrder]: any = useState({});

    const getOrderDetail = (order: Order) => {
        const { lineitems }: any = order;
        const { cardsenderinfo, cardrecipientinfo } = lineitems[0] || {};
        const { sendername, senderemail } = cardsenderinfo || {};
        const { recipientname, recipientemail } = cardrecipientinfo || {};
        return {
            ...order,
            sendername,
            senderemail,
            recipientname,
            recipientemail,
        };
    };

    useEffect(() => {
        if (util.isEmpty(order) && !util.isEmpty(response)) {
            setOrder(getOrderDetail(response));
        }
    });

    /**
     * This function will be called for each card on first render
     */
    const setBalance = async (card: GiftCard) => {
        const cards: GiftCard[] = [...order.lineitems];
        const index = cards.findIndex((x) => x.carddetid === card.carddetid);
        const ser = new Service();
        const res: any = await ser.getBalance(card.clientcardsrno || '');
        if (res?.status === 0) {
            cards[index].balance = res.balance;
            setOrder({ ...order, lineitems: cards });
            return;
        }
        cards[index].balance = null;
        setOrder({ ...order, lineitems: cards });
    };

    const updateCardSchedule = async (
        clientcardsrno: string,
        carddetid: number,
        shipdate: number,
    ) => {
        const ser = new Service();
        const res: any = await showLoader(
            ser.updateCardSchedule(clientcardsrno, carddetid, shipdate),
        );
        if (!res || res.status) {
            showToast({
                title: 'Failed!',
                content: res?.message,
                variant: ToastVariants.DANGER,
            });
            return;
        }
        if (res.status === 0) {
            showToast({
                title: 'Date updated!',
                content: res.message,
                variant: ToastVariants.SUCCESS,
            });
            setOrder({
                ...order,
                lineitems: order.lineitems.map((item: GiftCard) => {
                    if (item.carddetid === carddetid) {
                        return {
                            ...item,
                            shipdate: new Date(shipdate),
                        };
                    }
                    return item;
                }),
            });
        }
    };

    const { group, merchant } = order || {};

    return (
        <Container fluid className="order">
            <Row>
                <Col className="d-flex page-title">
                    <div>
                        <Text type={TextTypes.H2} className="d-none d-md-block mb-48">
                            Welcome, {order.sendername}
                        </Text>
                        <Text type={TextTypes.H3} className="d-md-none d-sm-block">
                            Welcome <br /> {order.sendername}
                        </Text>
                    </div>
                    <div className="d-none d-md-block">
                        <Button
                            className="buy-btn"
                            onClick={() => {
                                window.open(
                                    `${constants.E_GIFT_CARD_URL}/${group?.groupId}/${merchant?.merchantId}/?source=web_merchant&return_url=${window.location.href}`
                                );
                            }}
                        >
                            Buy another E-Gift card
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row className="d-none d-md-block">
                <Col>
                    <Text type={TextTypes.H3} className="order-name">
                        Order #{order.orderno}
                    </Text>
                    <br />
                </Col>
            </Row>
            <Row className="order-md d-none d-md-flex">
                <OrderDesktop
                    order={order}
                    setBalance={setBalance}
                    updateCardSchedule={updateCardSchedule}
                />
            </Row>
            <Row className="order-sm d-md-none d-sm-flex">
                <OrderMobile
                    order={order}
                    setBalance={setBalance}
                    updateCardSchedule={updateCardSchedule}
                />
            </Row>
            <Button
                className="d-md-none d-sm-flex buy-btn"
                onClick={() => {
                    window.open(
                        `${constants.E_GIFT_CARD_URL}/${group?.groupId}/${merchant?.merchantId}/?source=olo_web&return_url=${window.location.href}`
                    );
                }}
            >
                Buy another E-Giftcard
            </Button>
        </Container>
    );
}

const query = (params: any) => {
    return new Service().orderBySender(params.orderno);
};

export default styleLoader(OrderDetail, query);
